import { Icon, IconProps } from '@chakra-ui/react';

export function ForwardToIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.00033 7.82813L2.33366 3.66146V11.9948H9.83366V13.6615H2.33366C1.87533 13.6615 1.48296 13.4983 1.15658 13.1719C0.830187 12.8455 0.666992 12.4531 0.666992 11.9948V1.99479C0.666992 1.53646 0.830187 1.1441 1.15658 0.817708C1.48296 0.491319 1.87533 0.328125 2.33366 0.328125H15.667C16.1253 0.328125 16.5177 0.491319 16.8441 0.817708C17.1705 1.1441 17.3337 1.53646 17.3337 1.99479V7.82813H15.667V3.66146L9.00033 7.82813ZM9.00033 6.16146L15.667 1.99479H2.33366L9.00033 6.16146ZM14.8337 16.1615L13.667 14.9948L14.9795 13.6615H11.5003V11.9948H14.9795L13.6462 10.6615L14.8337 9.49479L18.167 12.8281L14.8337 16.1615ZM2.33366 3.66146V12.8281V7.82813V7.89063V1.99479V3.66146Z" />
    </Icon>
  );
}
